import {
  Route,
  Routes,
  BrowserRouter as Router,
  useLocation,
} from "react-router-dom";

import AddEditCustomer from "./components/Customers/AddEditCustomer";
import Customers from "./components/Customers/Customers";
import NavLayout from "./components/Layout/NavLayout";
// import Login from "./components/Login/Login";
import Logout from "./components/newLogin/Logout";
import Till from "./components/Till-Summary/Till";
import Setting from "./components/Settings/Setting";
import { CreateEditRole } from "./components/Roles/CreateEditRole";
import Permissions from "./components/Roles/Permissions";
import AddUsers from "./components/Users/addUsers";
import Users from "./components/Users/users";
import Suppliers from "./components/Suppliers/Suppliers";
import Invoices from "./components/Invoices/Invoices";
import AddEditSupplier from "./components/Suppliers/AddEditSupplier";
import Warehouses from "./components/Warehouse/Warehouses";
import Information from "./components/Till-Information/Information";
import Inventory from "./components/Inventory/inventory";
import DashboardInventory from "./components/Dashboard/dashboardInventory";
import Exchange from "./components/ExchangeRate/exchange";
import { GeneralDashboard } from "./components/Dashboard/GeneralDashboard";
import SupplierBalance from "./components/SupplierBalance/balance";
import DashboardPurchase from "./components/Dashboard/dashboardPurchase";
import AddEditWarehouses from "./components/Warehouse/AddEditWarehouse";
import AddEditItem from "./components/Inventory/AddEditItem";
import { useTranslation } from "react-i18next";
import Billings from "./components/Bills/Bills";
import ItemBills from "./components/Bills/ItemBill";
// import MainTwo from "./components/newMain/Maintwo";
import { Provider } from "react-redux";
import store from "./store";
import AddEditReferences from "./components/References/Tab";
import AddEditBills from "./components/Bills/AddEditBills";
import AddEditBillItemBill from "./components/Bills/AddEditItemBill";
import Category from "./components/Category/categories";
import AddEditCategory from "./components/Category/AddEditCategories";
import MainThree from "./components/newMain/MainThree";
import AddEditBill from "./components/Bills/AddEditBills";
import Price from "./components/PriceList/Price";
import PriceDetails from "./components/PriceList/PriceDetails";
import Roles from "./components/Roles/Roles";
import CustomerBalance from "./components/CustomerBalance/customerbalance";
import SupplierPayment from "./components/SupplierPayment/payment";
import AddEditSupplierBalance from "./components/SupplierPayment/AddEditPaymentSupplier";
import CustomerPayment from "./components/ReceiptsPayment/receipts";
import AddEditCustomerBalance from "./components/ReceiptsPayment/AddEditReceipts";
import InventorySummary from "./components/InventorySummary/inventorySummary";
import InventoryDetails from "./components/InventorySummary/inventoryDetails";
import NewLogin from "./components/newLogin/newLogin";
import Stock from "./components/Warehouse/stock";
import Returns from "./components/Returns/returns";
import AddEditReturn from "./components/Returns/AddEditReturn";
import ReturnsInvoices from "./components/Returns/ReturnInvoices/ReturnInvoice";
import Sales from "./components/SalesReturn/sales";
import "@fontsource/lato";
import MainFour from "./components/newMain/MainFour";
import Summarytables from "./components/SummaryTill/SummaryTables";
import { useEffect } from "react";
import Version from "./components/Version/Version";
import InventoryBeginning from "./components/InventoryBeginning/InventoryBeginning";
import Count from "./components/InventoryCount/Count";

import CountDetails from "./components/InventoryCount/CountDetails";

function ScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
function App() {
  const { i18n } = useTranslation();
  document.body.dir = i18n.dir();
  return (
    <div className="App">
      <Provider store={store}>
        <Router>
          <ScrollTop />
          <Routes>
            <Route path="/" element={<NewLogin />} />
            {/* <Route path="/" element={<Login />} /> */}
            <Route path="/logout" element={<Logout />} />
            <Route element={<NavLayout />}>
              <Route path="/mainCard" element={<MainThree />} />
              <Route path="/main" element={<MainFour />} />
              <Route path="/users" element={<Users />} />
              <Route path="/users/create" element={<AddUsers />} />
              <Route path="/users/:id" element={<AddUsers />} />
              <Route path="/customers" element={<Customers />} />
              <Route path="/customers/create" element={<AddEditCustomer />} />
              <Route path="/customers/:id" element={<AddEditCustomer />} />
              <Route path="/till/:id" element={<Till />} />
              <Route path="/settings" element={<Setting />} />
              <Route path="/permissions" element={<Permissions />} />
              <Route path="/roles" element={<Roles />} />
              <Route path="/roles/create" element={<CreateEditRole />} />
              <Route path="/roles/:id" element={<CreateEditRole />} />
              <Route path="/suppliers" element={<Suppliers />} />
              <Route path="/suppliers/create" element={<AddEditSupplier />} />
              <Route path="/suppliers/:id" element={<AddEditSupplier />} />
              <Route path="/invoices" element={<Invoices />} />
              <Route path="/GeneralDash" element={<GeneralDashboard />} />
              <Route path="/warehouses" element={<Warehouses />} />
              <Route path="/warehouses/:id" element={<AddEditWarehouses />} />
              <Route
                path="/warehouses/create"
                element={<AddEditWarehouses />}
              />
              <Route path="/stock/:id" element={<Stock />} />
              <Route path="/information" element={<Information />} />
              <Route path="/items" element={<Inventory />} />
              <Route path="/item/create" element={<AddEditItem />} />
              <Route path="/item/:id" element={<AddEditItem />} />
              <Route path="/cactegory" element={<Category />} />
              <Route path="/category/create" element={<AddEditCategory />} />
              <Route path="/category/:id" element={<AddEditCategory />} />
              <Route path="/exchange-rate" element={<Exchange />} />
              <Route path="/priceList" element={<Price />} />
              <Route path="/priceList/details/:id" element={<PriceDetails />} />
              <Route
                path="/dashboard/Purchase"
                element={<DashboardPurchase />}
              />
              <Route
                path="/dashboard/inventory"
                element={<DashboardInventory />}
              />
              <Route path="/bills" element={<Billings />} />
              <Route path="/billscreate" element={<AddEditBill />} />
              <Route path="/billsedit/:id" element={<AddEditBills />} />
              <Route path="/itembill/:billId" element={<ItemBills />} />
              <Route
                path="/itembill/:billId/create"
                element={<AddEditBillItemBill />}
              />
              <Route
                path="/itembill/:billId/edit/:itemId"
                element={<AddEditBillItemBill />}
              />
              <Route path="/itembill/:id" element={<AddEditBillItemBill />} />
              <Route path="/references" element={<AddEditReferences />} />
              <Route path="/supplierbalance" element={<SupplierBalance />} />
              <Route path="/customerbalance" element={<CustomerBalance />} />
              <Route path="/supplierpayment" element={<SupplierPayment />} />
              <Route
                path="/supplierpayment/:id"
                element={<AddEditSupplierBalance />}
              />
              <Route
                path="/supplierpayment/create"
                element={<AddEditSupplierBalance />}
              />
              <Route path="/customerreceipts" element={<CustomerPayment />} />
              <Route
                path="customerreceipts/create"
                element={<AddEditCustomerBalance />}
              />
              <Route
                path="/customerpayment/:id"
                element={<AddEditCustomerBalance />}
              />
              <Route path="/inventory/beginning" element={<InventoryBeginning />} />
              <Route path="/inventory/count" element={<Count />} />
              <Route path="/inventory/count/details/:id" element={<CountDetails />} />
              <Route path="/inventory/summary" element={<InventorySummary />} />
              <Route
                path="/inventory/summary/details/:id"
                element={<InventoryDetails />}
              />
              <Route path="/return" element={<Returns />} />
              <Route path="/return/create" element={<AddEditReturn />} />
              <Route path="/return/:id" element={<AddEditReturn />} />
              <Route path="/returninvoices/:id" element={<ReturnsInvoices />} />
              <Route path="/sales" element={<Sales />} />
              <Route path="/initial/:id" element={<Summarytables />} />
              <Route path="/version" element={<Version />} />
            </Route >
          </Routes >
        </Router >
      </Provider >
    </div >
  );
}

export default App;
